/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import $ from 'jquery';

import { queryParser } from '@/utils/query_parser';

import { Block } from './types';

window.jQuery = $;

const generateRelevantFiltersText = (block: Block, index: number) => {
  const relevantObjects = block.relatedFilters.map(filter => `#${filter.relevantType},${filter.objectId}#`);

  if (block.isRelevantToPrevious) {
    const previousBlockNumber = index - 1;
    relevantObjects.unshift(`#__previous__,${previousBlockNumber}#`);
  }

  return relevantObjects.join(' AND ');
};

const groupPrivateFilter = 'is_private = 0';

const addHiddenGroupFilter = (filter: string) => {
  if (filter.length == 0) {
    return groupPrivateFilter;
  }
  return `(${filter}) AND ${groupPrivateFilter}`;
};

export const generateSaveQuery = (configuration: Block[]) =>
  configuration.map((block: Block, index: number) => {
    const fields = block.attrs.filter(attribute => attribute.checked).map(attribute => attribute.key);

    const prevFilter = block.filter;
    if (block.objectType === 'Group') {
      block.filter = addHiddenGroupFilter(block.filter);
    }
    const filters = queryParser.join_queries(
      queryParser.parse(generateRelevantFiltersText(block, index)),
      queryParser.parse(block.filter)
    );
    filters.raw = block.filter;

    block.filter = prevFilter;
    return { object_name: block.objectType, fields, filters };
  });
